//Types
import {
  GET_ALLOWED_COUNTRIES,
  SET_ALLOWED_COUNTRIES_LOADING,
  ALLOWED_COUNTRIES_ERROR,
} from "./countryRestrictions.type";

//Define InitialState
const initialState = {
  allowedCountries: [], // [{ countryCode, countryName }]
  loading: false,
  error: null,
};

const countryRestrictionsReducer = (state = initialState, action) => {
  switch (action.type) {
    //Loading
    case SET_ALLOWED_COUNTRIES_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    //Get / Save both resolve to the current list
    case GET_ALLOWED_COUNTRIES:
      return {
        ...state,
        allowedCountries: action.payload,
        loading: false,
        error: null,
      };

    //Error
    case ALLOWED_COUNTRIES_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default countryRestrictionsReducer;
